module.exports = __webpack_public_path__ + "img/14.5d4c1e58.jpg";